/**
 * @desc checkCabinInfoByShipmentList
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = defs.tms.Response;
export function request(body: Array<string>, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/cabinMaster/checkCabinInfoByShipmentList`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
